import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import { SplitButton,Dropdown,Button } from 'react-bootstrap';
import {connect} from 'react-redux';



type MenuItemProps = {
    onCallback?: (theme:Tgcc.MerchandisingTheme) => void;
    key?:number;
    title?:string;
    theme?:Tgcc.MerchandisingTheme;
}



class _RealCampusMenuItem extends React.Component<MenuItemProps, any> {
    
    onClick = (evt: any) => {
        if (this.props.onCallback)
            this.props.onCallback(this.props.theme);
    }

    render() {
        return (
            <Dropdown.Item key={this.props.key} eventKey={this.props.key} className="dropdown item" onClick={this.onClick}>{this.props.title}</Dropdown.Item>
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};
export var RealCampusMenuItem = connect(mapStateToProps)(Radium(_RealCampusMenuItem));
